import { render, staticRenderFns } from "./personEditor.vue?vue&type=template&id=1f4ed69c&scoped=true&"
import script from "./personEditor.vue?vue&type=script&lang=js&"
export * from "./personEditor.vue?vue&type=script&lang=js&"
import style0 from "./personEditor.vue?vue&type=style&index=0&id=1f4ed69c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ed69c",
  null
  
)

export default component.exports